import { useState } from "react";
import "./styles/Questions.css";
import Header from "./Header";
import { Helmet } from "react-helmet";
import Footer from "./Footer";
import { motion } from "framer-motion";

const questionSections = [
  {
    title: "Rezervacija i plaćanje",
    questions: [
      {
        question: "Kako mogu da rezervišem smeštaj u apartmanu?",
        answer: `Rezervaciju smeštaja možete napraviti popunjavanjem forme na strani 
            <a href="/booking">Rezerviši</a> ili tako što ćete nas kontaktirati 
            direktno na brojeve telefona koji su prikazani na <a href="/contact">Kontakt</a> strani.`,
      },
      {
        question: "Koje su opcije plaćanja dostupne?",
        answer:
          "Plaćanje možete izvršiti prilikom dolaska u apartman ili uplatom na naš tekući račun.",
      },
      {
        question: "Da li je potrebno uplatiti depozit prilikom rezervacije?",
        answer:
          "U zavisnosti od sezone i dužine boravka, u nekim slučajevima je potrebno uplatiti depozit. Kontaktirajte nas radi detaljnijeg odgovora.",
      },
      {
        question: "Da li mogu da otkažem rezervaciju i dobijem povraćaj novca?",
        answer:
          "Otkazivanje rezervacije je moguće, ali je poželjno da nas blagovremeno obavestite o otkazivanju. Ukoliko otkažete najmanje 7 dana pre dolaska, depozit će biti vraćen u celosti. Otkazivanje u periodu kraćem od 7 dana može rezultirati zadržavanjem depozita, zavisno od okolnosti i politike otkazivanja.",
      },
      {
        question: "Da li mogu da promenim datum rezervacije?",
        answer:
          "Datum rezervacije možete promeniti u zavisnosti od dostupnosti apartmana. Kontaktirajte nas što pre kako bismo proverili mogućnosti.",
      },
      {
        question: "Da li dobijam potvrdu nakon rezervacije?",
        answer:
          "Da, nakon uspešne rezervacije dobićete email sa svim detaljima Vaše rezervacije.",
      },
      {
        question: "Postoji li minimalan broj noćenja za rezervaciju?",
        answer:
          "Minimalan broj noćenja za rezervaciju je 2 noći tokom vansezonskog perioda i 3 noći tokom sezone.",
      },
      {
        question: "Da li je moguće platiti karticom?",
        answer:
          "Trenutno prihvatamo samo gotovinsko plaćanje i uplatu na naš tekući račun.",
      },
    ],
  },
  {
    title: "Smeštaj i oprema",
    questions: [
      {
        question: "Da li apartman Stari Vlah ima parking?",
        answer:
          "Da, apartman Stari Vlah ima obezbeđeno parking mesto u blizini ulaza u objekat.",
      },
      {
        question: "Da li apartman Stari Vlah ima Wi-Fi?",
        answer: "Da, u apartmanu je dostupan besplatan Wi-Fi internet.",
      },
      {
        question: "Da li apartman Stari Vlah ima televizor?",
        answer:
          "Da, apartman je opremljen modernim smart televizorom sa kablovskom televizijom.",
      },
      {
        question: "Da li je u apartmanu Stari Vlah dostupan fen za kosu?",
        answer: "Da, u apartmanu je dostupan fen za kosu.",
      },
      {
        question: "Da li apartman ima potpuno opremljenu kuhinju?",
        answer:
          "Da, kuhinja je potpuno opremljena sa svim potrebnim aparatima i posuđem za pripremu obroka.",
      },
      {
        question: "Da li apartman ima balkonski prostor?",
        answer:
          "Da, apartman ima terasu sa stolom i stolicama, idealnu za opuštanje.",
      },
    ],
  },
  {
    title: "Politika i pravila",
    questions: [
      {
        question: "Koje su procedure prijave i odjave u apartmanu Stari Vlah?",
        answer:
          "Prijava je od 14:00 časova, a odjava je do 11:00 časova. U slučaju da želite kasniji check-out, obavezno nas kontaktirajte unapred da proverimo dostupnost.",
      },
      {
        question: "Da li su kućni ljubimci dozvoljeni?",
        answer:
          "Kućni ljubimci su u našem smeštaju dozvoljeni, ali je moguća naplata naknade za čišćenje. Molimo Vas da nas kontaktirate za više informacija.",
      },
      {
        question: "Da li je moguća kasna prijava (late check-in)?",
        answer:
          " Da, kasna prijava je moguća, ali je potrebno da nas unapred obavestite o tačnom vremenu dolaska.",
      },
    ],
  },
  {
    title: "Održavanje i čišćenje",
    questions: [
      {
        question: "Da li je čišćenje uključeno u cenu boravka?",
        answer:
          "Da, čišćenje apartmana je uključeno u cenu boravka. Naše osoblje obavlja osnovno čišćenje pre vašeg dolaska i nakon vašeg odlaska.",
      },
      {
        question:
          "Kako mogu da zatražim dodatno čišćenje ili promenu posteljine?",
        answer:
          "Dodatno čišćenje ili zamena posteljine mogu se organizovati na zahtev. Molimo vas da nas obavestite najmanje 24 sata unapred kako bismo mogli da planiramo servis.",
      },
      {
        question:
          "Da li apartman ima sredstva za čišćenje ako želim da obavim čišćenje tokom boravka?",
        answer:
          " Da, u apartmanu se nalaze osnovna sredstva za čišćenje, kao što su sredstva za pranje posuđa, brisanje prašine i slični proizvodi. Ako vam nešto nedostaje, slobodno nas kontaktirajte.",
      },
      {
        question:
          "Kako mogu da obavestim osoblje o problemima sa uređajima ili opremom?",
        answer:
          " Ako imate bilo kakav problem sa uređajem ili opremom, molimo vas da nas odmah obavestite. Naša ekipa će brzo reagovati i rešiti problem u najkraćem mogućem roku.",
      },
    ],
  },
];

function Questions() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <Header />
      <div className="mainQuestionsDiv">
        <Helmet>
          <title>
            Često postavljena pitanja | Apartman Stari Vlah Zlatibor | Smeštaj Zlatibor
          </title>
          <meta
            name="description"
            content="Saznajte odgovore na najčešće postavljana pitanja vezana za rezervaciju, plaćanje, opremu i pravila boravka u Apartmanu Stari Vlah na Zlatiboru."
          />
          <meta
            name="keywords"
            content="česta pitanja smeštaj Zlatibor, kako iznajmiti apartman Zlatibor, apartmani Zlatibor pitanja i odgovori, pravila boravka Zlatibor, parking apartmani Zlatibor, kućni ljubimci apartmani Zlatibor, otkazivanje rezervacije Zlatibor, prijava i odjava apartmani Zlatibor" 
          />
        </Helmet>
        <div className="questionHeadImgDiv">
          <img src="/images/faqImg.jpg" className="questionHeadImg" />
          <h1 className="questionsNameHeader">Apartman Stari Vlah</h1>
          <motion.h2 className="questionsMainHeader" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>Često postavljena pitanja</motion.h2>
          <motion.h3 className="questionsMainParagraph" initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ duration: 1.3, ease: "easeOut" }}>Vaša pitanja, naši odgovori – sve na jednom mestu!</motion.h3>
        </div>


        <div className="questionListDiv">
          {questionSections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="faqSection" >
              <h3 className="questionSection">{section.title}</h3>
              {section.questions.map((faq, index) => {
                const questionId = `${sectionIndex}-${index}`;
                const isOpen = openIndex === questionId;

                return (
                  <motion.div key={questionId} className="questionDiv" initial={{ y:100, opacity: 0 }}
                  whileInView={{ y: 0, opacity: 1 }}
                  transition={{ duration: 0.8,}}
                  viewport={{ once: true, amount: 0.7 }}>
                    <div
                      className="questionRowDiv"
                      onClick={() => toggleFAQ(questionId)}
                    >
                      <p className="questionHeader">{faq.question}</p>
                      <img
                        src={isOpen ? "/images/minus.png" : "/images/plus.png"}
                        className="questionIcon"
                        alt="Expand or Collapse FAQ Section"
                        loading="lazy"
                      />
                    </div>
                    <div className={`answerContainer ${isOpen ? "open" : ""}`}>
                      <p
                        className="answerParagraph"
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                      ></p>
                    </div>
                  </motion.div>
                );
              })}
            </div>
          ))}
        </div>
        <Footer />
      </div>
    </>
  );
}

export default Questions;
